<div class="page-header-outer">
    <div class="page-header">
        <h1>Users</h1>
        <div class="controls">
            <button [disabled]="!addButtonEnabled" (click)="onAddUserClick()"><span class="icon-plus"></span> Add New</button>
        </div>
    </div>    
</div>
<div class="content-inner">
    <div class="admin-main" [ngClass]="{'loading': initialLoading || mobileLoading }" >
        <div>
            <div class="admin-list" [ngClass]="{'loading': adminListLoading }"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="scrollThrottle"
                [fromRoot]="false"
                [scrollWindow]="false"
                [infiniteScrollContainer]="scrollSelector"
                (scrolled)="onScrollDown()">           
                <div class="filter-sort">
                <div class="filter">
                    <input class="compact magic-filter" (keyup)="onSearchKey($event)" [(ngModel)]="searchText" name="SearchKey" type="text" placeholder="Search by Name">
                </div>
                <div class="sort">
                    <label class="compact">Sort</label>
                    <select class="compact" (change)="onSortTypesDropDownChanged($event)" [(ngModel)]="selectedFilter" name="SortList">
                        <option *ngFor='let type of sortTypes' [value]="type" (change)="setSelectedFilter($event)">
                            {{type}}
                        </option>
                    </select> 
                    <a class="arrow compact" (click)="onChangeSortOrder()" 
                        [ngClass]="sortAscending ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold'"></a>
                </div>
            </div>
            <ul class="adminListScroll" > 
                <li *ngFor="let user of users" [value]="user.id" (click)="onSelection(user)" 
                    [ngClass]="{'active': selection != undefined && selection != null && user.id == selection.id } ">
                    <ul class="flags">
                        <li class="active">
                            <div class="added">
                                <span class="active">
                                    <div *ngIf="user.mostRecent">
                                        <span class="icon-plus"></span> New
                                    </div>
                                </span>                                                    
                            </div>
                        </li>
                    </ul>
                    <div class="title">{{ user.firstName + " " + user.lastName }}</div>
                    <ul class="details">
                        <li class="modified">
                            <span class="label">Email</span>
                            <span class="value">{{ user.email }}</span>
                        </li> 
                        <li class="modified">
                            <span class="label">Last Modified</span>
                            <span class="value">{{ user.modifiedDate == null ? "&nbsp;" : ( user.modifiedDate + "Z" | date: 'M/dd/yy h:mm a') }}</span>
                        </li> 
                    </ul> 
                </li> 
            </ul>
        </div> 
        <div class="admin-action-window" [ngClass]="{ 'loading': adminActionLoading }"> 
            <div class="admin-action suppress-scroll" id="edit" [ngClass]="{ 'active': showAdminActionWindow }" *ngIf="selection">
                <div class="header">
                    <div class="title">
                        {{ adminActionLabelText }}	                        
                        <a class="close" href="javascript:void(0)" (click)="onCancel()"><span class="icon-cross"></span></a>
                    </div>
                </div>
                <div>
                    <form #userEditForm="ngForm" (ngSubmit)="onSave()">
                        <section>
                            <div class="body">
                                <div class="form-group">
                                    <label>First Name</label>
                                    <input type="text" 
                                        maxlength="100" 
                                        required 
                                        name="userFirstName" 
                                        [readonly]="readOnly" 
                                        [(ngModel)]="selectedFirstName">
                                </div>
                                <div class="form-group">
                                    <label>Last Name</label>
                                    <input type="text" 
                                        maxlength="100"
                                        required 
                                        name="userLastName"  
                                        [readonly]="readOnly" 
                                        [(ngModel)]="selectedLastName">
                                </div>
                                <div class="form-group">
                                    <label>Email Address</label>
                                    <input #email id = email type="text" 
                                        maxlength="255"
                                        required 
                                        name="userEmail" 
                                        pattern="^.+@[^\.].*\.[a-z]{2,}$"
                                        [disabled]="!enableEmail"
                                        [readonly]="readOnly" 
                                        [(ngModel)]="selectedEmail"
                                        (change)="onEmailExist(email.value)"
                                        >
                                        <span class="Validation" *ngIf="email.errors?.required && email.touched">
                                            Email is required.
                                        </span>
                                        <span class="Validation" *ngIf="email.errors?.pattern && email.touched">
                                            Please enter a valid email address.
                                        </span>
                                        <span class="Validation" *ngIf="duplicateEmailError">
                                            {{ emailErrorMessage }}
                                        </span> 
                                </div>
                                <hr>
                                <div class="form-group">
                                    <label>Role</label>
                                    <select *ngIf="enableSelectedRole" 
                                        required 
                                        name="userRole" 
                                        id="rolesDropdown" 
                                        [disabled]="!enableSelectedRole || readOnly" 
                                        [(ngModel)]="selectedRoleId" 
                                        class="body-dropdown"
                                        (change)="onRoleChange()">
                                        <option *ngFor="let role of roles" [ngValue]="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <select *ngIf="!enableSelectedRole" disabled class="body-dropdown">
                                        <option>{{ getRoleName(selection.applicationRoleId) }}</option>
                                    </select>                                                                      
                                </div>
                                <div class="form-group" *ngIf=isShiftLeaderRoleSelected>
                                    <label> <input type="checkbox" name="shiftLeaderReportAccess" [(ngModel)]="selectedShiftLeaderReportAccess"/>Report Access</label>
                                </div>  
                            </div>
                            <div class="footer">
                                <div>
                                    <label class="errormsg">{{ getErrorMessage() }}</label> 
                                </div>
                                <button class="primary" type="submit" [disabled]="!userEditForm.form.valid || !userEditForm.dirty || !saveButtonEnabled || duplicateEmailError ">
                                    <span class="icon-plus"></span> Save</button>
                                <button class="cancel" type="button" (click)="onCancel()" [disabled]="saveLoading">
                                    <span class="icon-cancel"></span> Cancel</button>
                            </div>
                        </section>
                    </form>
                </div>      
            </div>
        </div>
    </div>
</div>